import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { withStyles, withTheme } from "@material-ui/core";
import { vehicleHistoryStyles } from "./subcomponents/sharedStyles";
import Typography from "../../../components/Helpers/Typography";
import useMediaQuery from "../../../hooks/useMediaQuery";

const TimelineHeader = ({ classes, theme, t }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <div className={`${classes.eventHeaderRow} ${classes.timelineHeader}`}>
      <div className={classes.timelineStatus}>
        <Typography color="lightgrey">{t("Vehicles.Detail.History.State")}</Typography>
      </div>
      <div className={`${classes.stats} ${classes.headerStats}`}>
        <div className={`${classes.dataField} ${classes.smallDataField}`}>
          <Typography color="lightgrey">{t("Vehicles.Detail.History.StartTime")}</Typography>
        </div>
        {!isMobile && (
          <div>
            <Typography color="lightgrey" className={classes.dataField}>
              {t("Vehicles.Detail.History.Duration")}
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
};

TimelineHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default withStyles(vehicleHistoryStyles)(
  withTheme(withTranslation("common")(TimelineHeader)),
);
